export const chartLightColors = [
  '#D9D9D91A',
  '#D9D9D933',
  '#D9D9D966',
  '#D9D9D999',
  '#D9D9D9CC'
]

export const chartDarkColors = [
  '#4D4D4D1A',
  '#4D4D4D33',
  '#4D4D4D66',
  '#4D4D4D99',
  '#4D4D4DCC'
]
